const fields = [
  {
    label: 'Template',
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: 'Deskripsi',
    key: 'description',
    isSortable: true,
  },
  {
    label: 'Dibuat Oleh',
    key: 'created_by',
    isSortable: true,
  },
  {
    label: 'Tanggal Dibuat',
    key: 'created_on',
    isSortable: true,
  },
  {
    label: 'Target Diambil',
    key: 'expected_pickup_on_interval',
    isSortable: true,
  },
  {
    label: 'Target Terkirim',
    key: 'expected_delivered_on_interval',
    isSortable: true,
  },
]

export default fields
